import {useEffect, useState,useContext} from 'react';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { Card,CardBody,CardHeader, ModalFooter } from 'reactstrap';
import {HiPencil} from 'react-icons/hi';
import { DataFirmaCertificado } from '../../interfaces/Certificados';
import { CasUserContext } from '../../services/casUserContext'; 
import Checkbox from '@mui/material/Checkbox';
import { number } from 'yup';
import { firmaCertificado } from '../../interfaces/Certificados';
import { Padding, Sync } from '@mui/icons-material';
import { Modal as ModalStrap, ModalHeader, ModalBody,TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import Typography from '@mui/material/Typography';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { Alert, AlertTitle, Button } from '@mui/material';
import ComboBox from './ComboBox';
import { FirmaCertificados } from '../../interfaces/Certificados';
import CertificadoService from '../../services/CertificadoService';
import AlertService from '../../services/AlertService';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        margin: theme.spacing(1),
      },
    },
  }),
);

const certificadoService = new CertificadoService();
const alertaService = new AlertService();

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
    border: 0,
    },
}));



export default function SolicitarFirmaTable(props: DataFirmaCertificado){
    const options = [
        { value: 'D', label: 'Firma Decano' },
        { value: 'DS', label: 'Firma Decano Subrrogante' },
      ];

      const vacio ={ value: '', label: '' }

      const [selectedOption, setSelectedOption] = useState(vacio);
    
      const handleComboBoxChange = (selectedOption: any) => {
        setSelectedOption(selectedOption);
      };
    
    const classes = useStyles();

    let [seleccionadosFirma, setSeleccionadosFirma] = useState<Array<firmaCertificado>>([]);

    const [userModal,setUserModal] = useState(false);
    const handleOpenUserModal = () => {
        printCheckeados();
        //console.log(seleccionHecha)
        setUserModal(true);
    }
    const handleCloseUserModal = () => {
        setSeleccionadosFirma(new Array<firmaCertificado>)
        setUserModal(false);
    }
    const toggleModal = () => {
        setSeleccionadosFirma(new Array<firmaCertificado>)
        setUserModal(!userModal);
    };
    const casUserContext = useContext(CasUserContext);
    let history = useNavigate()
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(props.rowsPerPage[0]);
    const handleChangePage = (event: unknown, newPage: number) => {
        checkedState.fill(false);
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const goToNavigation = (site:string) =>{
        history(site)
    }

    const handleAfterGenerarFirma=(redireccionar: boolean)=>{
        if(redireccionar){
            goToNavigation('/MisCertificados');
        }
    }

    const [checkedState, setCheckedState] = useState<boolean[]>(
        new Array<boolean>(props.data.length).fill(false)
      );
      
      const handleOnChange = (position: number): void => {
        const updatedCheckedState = checkedState.map((item, index) =>
          index === position ? !item : item
        );
        setCheckedState(updatedCheckedState);
      };

      const printCheckeados =()=>{
        checkedState.map((obj, index)=>{
            if(obj===true){
                seleccionadosFirma.push(props.data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)[index])
            }
        })
      }

    const generarCertificado=async ()=>{
        //console.log(seleccionadosFirma);
        //console.log(selectedOption.value);
        //console.log(casUserContext.userData.username);
        alertaService.showLoading("Generando Certificados");

        const resp = await certificadoService.GenerarCertificadosFirmas(seleccionadosFirma,casUserContext.userData.username,selectedOption.value,casUserContext.token);
          alertaService.hideLoading();
          if(resp.strEstado == 'S') {
             alertaService.alertaExito("Exito","Se generaron los certificados. A continuación se redireccionará a la sección de Mis Certificados");
             setTimeout(() => {
                goToNavigation('/MisCertificados');
             }, 3000);
             
          }else{
             alertaService.alertaAdvertencia("Error",resp.strMensaje);
          }
        /*if(seleccionadosFirma.length>2){
            handleAfterGenerarFirma(true);
            console.log("ES MAYOR A 2");
        }else{
            console.log("ES MENOR A 2");
            handleAfterGenerarFirma(false);
        }*/
        
        

    }  
  
    return (
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <Card>
                
            <CardBody>
                <div className={classes.root} style={{display:'flex', zIndex:999 ,position:'relative'}}>
                    <Button size="small" variant="contained" className='p-2' onClick={handleOpenUserModal}  >Generar Certificado</Button>
                    <div style={{width:'auto'}} >
                        <ComboBox options={options} onChange={handleComboBoxChange} placeHolder='Seleccione una opción de firma' name='combo' porDefecto={selectedOption.value!='' ? selectedOption : null }/>
                    </div>
                </div>
                
            <TableContainer sx={{ maxHeight: 600 }}>
            <Table stickyHeader aria-label="sticky table" >
                <TableHead>
                    <TableRow>
                        <StyledTableCell></StyledTableCell>
                        <StyledTableCell align="left">Título</StyledTableCell>
                        <StyledTableCell align="left">Rol de {casUserContext.userData.apellidos +" "+ casUserContext.userData.nombres + " ("+casUserContext.userData.emailAddress+")"}</StyledTableCell>
                        <StyledTableCell align="left">Estado</StyledTableCell>
                    </TableRow>
                
                </TableHead>
                <TableBody>
                {props.data.length > 0 ? props.data
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => {
                    return (
                        <StyledTableRow key={row.iddecinvproyecto}>
                            <StyledTableCell align="left">
                                <Checkbox 
                                    value={row.iddecinvproyecto}    
                                    checked={checkedState[index]}
                                    onChange={() => handleOnChange(index)}/>
                                </StyledTableCell> 
                            <StyledTableCell align="left">{row.titulo}</StyledTableCell>       
                            <StyledTableCell align="left">{row.rol_participante}</StyledTableCell>              
                            <StyledTableCell align="left">{row.estado_proyecto}</StyledTableCell>
                        </StyledTableRow>
                        );
                    }):
                    <StyledTableRow key={0}>
                        <StyledTableCell align="center"></StyledTableCell>
                        <StyledTableCell align="center"></StyledTableCell>
                        <StyledTableCell align="center">No existen proyectos</StyledTableCell>
                        <StyledTableCell align="center"></StyledTableCell>
                    </StyledTableRow>
                    }
                </TableBody>
            </Table>
            </TableContainer>
            <TablePagination
            rowsPerPageOptions={props.rowsPerPage}
            component="div"
            count={props.data.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            />
            </CardBody>
            </Card> 

            {
                seleccionadosFirma.length>0 && selectedOption.value!=='' ? 
                <ModalStrap isOpen={userModal} toggle={toggleModal} className="custom-modal" variant="h2"  style={{maxWidth:'50%'}}>
                    <ModalHeader toggle={toggleModal}>
                        <Typography style={{fontSize:'18px'}}><strong>¿Desea Generar el certificado de los siguientes proyectos con {selectedOption.label}?</strong></Typography>
                    </ModalHeader>
                    <ModalBody>
                        <ul>
                            {
                                seleccionadosFirma.map((row,index)=>{
                                    return(<li key={row.iddecinvproyecto}>{row.titulo}</li>);
                                })
                            }
                        </ul>
                    </ModalBody>
                    <ModalFooter style={{margin:'spacing'}} >
                    <div className={classes.root}>
                        <Button size="small" variant="outlined" color="error" onClick={handleCloseUserModal}>Cancelar</Button>
                        <Button size="small" variant="contained" onClick={generarCertificado} >Generar Certificado</Button>
                    </div>
                </ModalFooter>
                </ModalStrap>
                : 
                <ModalStrap isOpen={userModal} toggle={toggleModal} className="custom-modal" variant="h2"  style={{maxWidth:'50%'}}>
                    <ModalHeader>
                        <Typography style={{fontSize:'18px'}}><strong>Ningún proyecto seleccionado</strong></Typography>
                    </ModalHeader>
                    <ModalBody>
                        <Alert severity="error">
                            <AlertTitle>Error</AlertTitle>
                            <ul>
                                <li>Debe escoger al menos un proyecto para generar el certificado</li>
                                <li>Debe escoger el tipo de firma deseada</li>
                            </ul>
                        </Alert>
                    </ModalBody>
                </ModalStrap>
            } 
                
        </Paper>
        );

}